module.exports = __webpack_public_path__ + "fonts/Roboto-700-cyrillic50.f92ee38.woff2";